import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { IMainstreetEvent } from '../classes';
import { calendarDispatch } from '../calendar'
import { togglePriceFilter } from '../actions';

interface ICalendarFiltersPrice {
    selectedPriceFilter: boolean;
}

class CalendarFiltersPrice extends React.Component<ICalendarFiltersPrice, any>{

    constructor(props) {
        super(props);
        var monthCounter = moment();
    }

    render() {
        return (
            <div className="calendar-filter-price">
                <label>By Price</label>
                <input type="checkbox" id="testId" checked={this.props.selectedPriceFilter} onChange={this.sendAction.bind(this)} />
                <label htmlFor="testId">Only free events<span></span></label>
            </div>
        )
    }
    sendAction(e) {
        calendarDispatch()(togglePriceFilter());

    }
};

export default CalendarFiltersPrice;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/filters/calendar-filters-price.tsx